<div class="select-container wgu-outlined general">
  <input
    (click)="showOptions()"
    type="text"
    class="select-input"
    [id]="customId"
    [placeholder]=""
    [value]="formCtrl?.value"
    [disabled]="disabled"
    aria-label="option.label"
    readonly
  />
  <span>{{ label }}</span>
  <button (click)="showOptions()">
    <img
      alt="Expand Options"
      src="/assets/images/securityquestions/chevron_down.png"
      width="25"
    />
  </button>

  <ul class="select-menu box" role="listbox" *ngIf="expanded" style="list-style: none">
    <li
      role="option"
      *ngFor="let option of options; let i = index"
      [id]="customId + '-option-' + i"
      [title]="option.label"
      class="option-item"
      label="option.label"
      [ngClass]="{ selected: activeItemIndex === i }"
    >
      <button (click)="selectItem(option)">
        <span> {{ option.label }}</span>
      </button>
    </li>
  </ul>
</div>
